import { useState, type FormEvent } from "react";
import { useAuth } from "../hooks/useAuth";
import { StatusMessage } from "./StatusMessage";

interface LoginFormProps {
  onSuccess: (clientId: string) => void;
}

export function LoginForm({ onSuccess }: LoginFormProps) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const { status, error, login } = useAuth();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const result = await login(username, password);
    if (result) onSuccess(result.clientId);
  };

  const busy = status === "loading";

  return (
    <form className="nl-form" onSubmit={handleSubmit}>
      <label className="nl-field">
        <span className="nl-field__label">Base ID</span>
        <input
          className="nl-field__input"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter your Base ID"
          autoComplete="username"
          required
        />
      </label>

      <label className="nl-field">
        <span className="nl-field__label">Password</span>
        <input
          className="nl-field__input"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter Password"
          autoComplete="current-password"
          required
        />
      </label>

      <button className="nl-button" type="submit" disabled={busy}>
        {busy ? "Signing in…" : "Sign in"}
      </button>

      {status === "error" && (
        <StatusMessage variant="error" message={error ?? "Sign in failed."} />
      )}
    </form>
  );
}
